<template>
    <section class="modal" :class="[statusModal ? 'active' : ' ']">
        <div class="overlay" ></div>
        <div class="content">
            <div class="box" :class="size">
                <div class="avatar" v-if="hasAvatarSlot">
                    <slot name="avatar"></slot>
                </div>
                <div class="title">
                    <h2>{{title}}</h2>
                    <p>{{titleText}}</p>
                    <button type="button" @click="close()">
                        <i class="far fa-times"></i>
                    </button>
                </div>
                <div>
                    <slot></slot>
                </div>
            </div>
        </div>
        
    </section>
</template>

<script>
    import mixinAutoResize from "../../mixins/auto-resize.js";
    export default {
        name: 'login',
        components: {},
        mixins: [ mixinAutoResize ],
        computed: {
            hasTitles(){
                return this.$slots.default ? true : false
            },
            hasAvatarSlot() {
                return !!this.$slots.avatar
            },
        },
        props: {
            id: {
                type: String,
                required: false,
            },
            title: {
                type: String,
                required: false,
            },
            titleText: {
                type: String,
                required: false,
            },
            size: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                statusModal: false,
                form: {
                    assunto: '',
                    text: '',
                }
            }
        },
        methods: {
            open(id){
                if(this.id !== id){
                    return
                }
                document.getElementsByClassName('app')[0].style.cssText = 'overflow:hidden !important';
                setTimeout( () => {
                    this.statusModal = true
                }, 300)
            },
            hide(id){
                if(this.id !== id){
                    return
                }
                this.statusModal = false
                this.form = {
                    assunto: '',
                    text: '',
                }
                setTimeout( () => {
                    document.getElementsByClassName('app')[0].style.cssText = 'overflow:auto !important';
                }, 200)
            },
            close(){
                this.statusModal = false
                this.form = {
                    assunto: '',
                    text: '',
                }
                setTimeout( () => {
                    document.getElementsByClassName('app')[0].style.cssText = 'overflow:auto !important';
                }, 200)
			},
        },
        created(){
			this.$root.$on("modal", (id) => {
                this.open(id)
            })
            this.$root.$on("modal-close", (id) => {
                this.hide(id)
			})
		}
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
